<template>
	<div class="login-view">
		<AuthBackground/>
		<div class="content">
			<!-- logo -->
		<img src="@/assets/image/logo.png" alt="logo" class="logo-img">
		<!-- 登录表单 -->
		<el-form class="form" :model="loginForm" :rules="rules" ref="loginForm"
			@keyup.enter.native="submitForm()" v-loading="loading" :element-loading-text="$t('login.logging')">
			<div class="form-body">
				<el-form-item prop="terminal" v-show="false">
					<el-input type="terminal" v-model="loginForm.terminal"></el-input>
				</el-form-item>

				<!-- 登录方式切换 -->
				<div class="login-tabs">
					<div class="tab-item" :class="{ active: loginMode === 'code' }" @click="switchMode('code')">
						{{ $t('login.codeLogin') }}
					</div>
					<div class="tab-item" :class="{ active: loginMode === 'password' }" @click="switchMode('password')">
						{{ $t('login.passwordLogin') }}
					</div>
				</div>

				<!-- 手机号 -->
				<div class="form-label">
					<img class="label-icon" src="@/assets/image/icon-phone.png" alt="">
					<span>{{ $t('login.phone') }}</span>
				</div>
				<el-form-item prop="phone">
				<div class="phone-input">
					<el-select v-model="countryCode" class="area-code-select">
						<el-option v-for="item in countryCodeList" :key="item.areaCode"
							:label="'+' + item.areaCode" :value="item.areaCode"></el-option>
					</el-select>
					<div class="input-divider"></div>
					<el-input v-model="loginForm.phone" :placeholder="$t('login.inputPhone')" clearable>
					</el-input>
				</div>
			</el-form-item>

				<!-- 密码登录 -->
				<template v-if="loginMode === 'password'">
					<div class="form-label">
						<img class="label-icon" src="@/assets/image/icon-code.png" alt="">
						<span>{{ $t('login.password') }}</span>
					</div>
					<el-form-item prop="password">
						<div class="code-input">
							<el-input type="password" v-model="loginForm.password"
							:placeholder="$t('login.inputPassword')" clearable>
							</el-input>
						</div>
					</el-form-item>
					<!-- <div class="nav-tool-bar">
						<el-checkbox v-model="isAutoLogin">{{ $t('login.autoLogin') }}</el-checkbox>
						<router-link class="link" to="/password/reset">{{ $t('login.forgotPwd') }}</router-link>
					</div> -->
					<div class="nav-tool-bar">
						<router-link class="link" to="/password/reset">{{ $t('login.forgotPwd') }}</router-link>
						<router-link class="link" to="/register">{{ $t('login.noAccount') }}</router-link>
					</div>
				</template>

				<!-- 验证码登录 -->
				<template v-if="loginMode === 'code'">
					<div class="form-label">
						<img class="label-icon" src="@/assets/image/icon-code.png" alt="">
						<span>{{ $t('login.smsCode') }}</span>
					</div>
					<el-form-item prop="code">
						<div class="code-input">
							<el-input v-model="loginForm.code" :placeholder="$t('login.inputCode')" clearable>
							</el-input>
							<div class="input-divider"></div>
							<el-button class="code-btn" type="text" :disabled="codeLockTime > 0"
								@click="onSendCode()">
								{{ codeLockTime > 0 ? $t('login.resendAfter', { n: codeLockTime }) : $t('login.getCode') }}
							</el-button>
						</div>
					</el-form-item>
				</template>

				<el-button class="submit-btn" type="primary" @click="submitForm()">{{ $t('login.login') }}</el-button>
				<router-link v-if="isEnableDemo" class="demo-login-link" to="/login/demo">
					{{ $t('login.demoLogin') }}
				</router-link>
			</div>
		</el-form>
		<!-- 底部标题 -->
		<img src="@/assets/image/login-footer-title.png" class="login-footer-title">
		</div>
		<!-- <icp></icp> -->
		<captcha-image ref="captchaRef"></captcha-image>
	</div>

</template>

<script>
import Icp from '../components/common/Icp.vue'
import AuthBackground from '../components/common/AuthBackground.vue'
import CaptchaImage from '../components/common/CaptchaImage.vue'
import * as auth from '../api/auth.js'

export default {
	name: "login",
	components: {
		Icp,
		AuthBackground,
		CaptchaImage
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('login.inputPhone')));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (this.loginMode !== 'password') {
				return callback();
			}
			if (!value) {
				return callback(new Error(this.$t('login.inputPassword')));
			}
			callback();
		};
		var checkCode = (rule, value, callback) => {
			if (this.loginMode !== 'code') {
				return callback();
			}
			if (!value) {
				return callback(new Error(this.$t('login.inputCode')));
			}
			callback();
		};
		return {
			loading: false,
			isAutoLogin: true,
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				phone: '',
				password: '',
				code: ''
			},
			rules: {
				phone: [{
					validator: checkPhone,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				code: [{
					validator: checkCode,
					trigger: 'blur'
				}]
			},
			loginMode: 'code',
			codeLockTime: 0,
			codeLockTimer: null,
			countryCode: '86',
			countryCodeList: []
		};
	},
	methods: {
		submitForm() {
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					this.loading = true;
					let url, data;
					if (this.loginMode === 'password') {
					url = "/login";
					data = {
						terminal: this.loginForm.terminal,
						phone: this.loginForm.phone,
						password: this.loginForm.password,
						areaCode: this.countryCode,
						deviceType: this.configStore.electronMode ? '桌面端' : '网页端',
						deviceOs: /Win/i.test(navigator.platform) ? 'Windows' : (/Mac/i.test(navigator.platform) ? 'Mac' : navigator.platform),
					};
					} else {
						url = "/login/sms";
						data = {
							terminal: this.loginForm.terminal,
							phone: this.loginForm.phone,
							code: this.loginForm.code,
							areaCode: this.countryCode,
							deviceType: this.configStore.electronMode ? '桌面端' : '网页端',
							deviceOs: /Win/i.test(navigator.platform) ? 'Windows' : (/Mac/i.test(navigator.platform) ? 'Mac' : navigator.platform),
						};
					}
					this.$http({
						url: url,
						method: 'post',
						data: data
					}).then((data) => {
						auth.saveLoginSession(data, {
							autoLogin: this.isAutoLogin,
							userName: this.loginForm.phone
						});
						this.$message.success(this.$t('login.loginSuccess'));
						this.$router.push("/home/chat");
					}).finally(() => {
						this.loading = false
					})
				}
			});
		},
		switchMode(mode) {
			this.loginMode = mode;
			this.$refs.loginForm && this.$refs.loginForm.clearValidate();
		},
		onSendCode() {
			if (this.codeLockTime > 0) return;
			if (!this.loginForm.phone) {
				this.$message.error(this.$t('login.inputPhone'));
				return;
			}
			this.$refs.captchaRef.open((id, code) => {
				this.codeLockTime = 60;
				this.codeLockTimer && clearInterval(this.codeLockTimer);
				this.codeLockTimer = setInterval(() => {
					this.codeLockTime -= 1;
					if (this.codeLockTime <= 0) {
						this.codeLockTimer && clearInterval(this.codeLockTimer);
					}
				}, 1000)
				this.$http({
					url: "/captcha/sms/code",
					method: 'post',
					data: {
						phone: this.loginForm.phone,
						id: id,
						code: code,
						areaCode: this.countryCode
					}
				}).then(() => {
					this.$message.success(this.$t('register.smsSent'));
				})
			});
		},
		autoLogin() {
			this.loading = true;
			auth.refreshLogin().then(() => {
				this.$router.push("/home/chat");
			}).catch(() => {
				auth.clearLoginSession(true);
			}).finally(() => {
				this.loading = false;
			});
		},
		clearTimers() {
			this.codeLockTimer && clearInterval(this.codeLockTimer);
		},
		getPhoneAreaCodeList() {
			this.$http({
				url: '/system/phoneAreaCode/list',
				method: 'get'
			}).then(res => {
				if (res && res.length > 0) {
					this.countryCodeList = res;
					this.countryCode = res[0].areaCode;
				}
			}).catch(() => {
				this.countryCodeList = [{ country: '中国', areaCode: '86' }];
			});
		}
	},
	mounted() {
		this.isAutoLogin = auth.isAutoLoginEnabled();
		this.loginForm.phone = auth.getSavedUsername();
		// 加载区号列表
		this.getPhoneAreaCodeList();
		// 加载配置
		this.configStore.loadConfig();
		// electron 窗口大小（frame:false，即内容区尺寸；表单 380×460）
		window.electronAPI && window.electronAPI.sendEvent('resize', {
			width: 1200,
			height: 900,
			maximizable: true
		})
		if (this.isAutoLogin) {
			this.autoLogin();
		}
	},
	beforeDestroy() {
		this.clearTimers();
	},
	computed: {
		isEnableDemo() {
			return process.env.VUE_APP_IS_ENABLE_DEMO == 'true';
		}
	}
}
</script>

<style scoped lang="scss">
.login-view {
	position: relative;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: #fff;
	overflow: hidden;

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
		z-index: 1;
	}

	.logo-img {
		width: 84px;
		height: 112px;
	}

	.login-footer-title {
		width: 224px;
		height: 48px;
	}

	.form {
		width: 440px;
		background: #FFFFFF;
		border-radius: 24px;
		margin: 40px 0;
		padding: 24px;
	}

	.form-body {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-height: 0;
	}

	.login-tabs {
		display: flex;
		align-items: center;
		height: 64px;
		background: rgba(247, 249, 252, 1);
		border-radius: 16px;
		padding: 8px;
		margin-bottom: 8px;
		box-sizing: border-box;
		.tab-item {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 48px;
			border-radius: 12px;
			font-size: 16px;
			font-weight: bold;
			color: rgba(135, 142, 153, 1);
			cursor: pointer;
			transition: all 0.2s ease;

			&.active {
				background: #fff;
				color: rgba(31, 90, 255, 1);
			}
		}
	}

	.form-label {
		display: flex;
		align-items: center;
		margin-top: 24px;
		margin-bottom: 16px;
		font-size: 16px;
		font-weight: bold;
		color: rgba(90, 95, 102, 1);

		.label-icon {
			width: 16px;
			height: 16px;
			margin-right: 8px;
		}
	}

	.phone-input,
	.code-input {
		display: flex;
		align-items: center;
		height: 48px;
		border: 1px solid rgba(245, 247, 250, 1);
		border-radius: 12px;
		padding: 0 16px;
		transition: border-color 0.2s ease;

		&:focus-within {
			border-color: rgba(31, 90, 255, 1);
		}

		.area-code-select {
			width: 60px;
			flex-shrink: 0;
			::v-deep .el-input__inner {
				border: none;
				background: transparent;
				padding: 0 !important;
				font-size: 16px;
				font-weight: bold;
				color: rgba(31, 31, 31, 1);
				height: 46px;
				line-height: 46px;
			}

			::v-deep .el-input__suffix {
				right: 0;
			}

			::v-deep .el-input__icon {
				font-size: 12px;
				color: rgba(31, 31, 31, 1);
			}
		}

		.input-divider {
			width: 1px;
			height: 12px;
			background: rgba(247, 249, 252, 1);
			margin: 0 12px;
		}

		.el-input {
			flex: 1;
		}
	}

	.form-body ::v-deep .el-form-item {
		margin-bottom: 0;

		.el-input__inner {
			height: 46px;
			border: none;
			background: transparent;
			padding-left: 0;
			padding-right: 24px;
			font-size: 16px;
			color: rgba(31, 31, 31, 1);
			box-shadow: none;
			&::placeholder {
				color: rgba(135, 142, 153, 1);
				font-size: 16px;
			}
		}

		.el-input__suffix {
			right: 0;
		}

		.el-input__suffix-inner {
			color: rgba(0, 0, 0, 0.4);
			font-size: 16px;
		}

		.el-input__clear {
			font-size: 20px;
		}
	}

	.code-btn {
		font-size: 16px;
		font-weight: normal;
		color: rgba(162, 171, 184, 1);
		padding: 0;
		margin-left: 0;

		&:not(.is-disabled) {
			color: rgba(31, 90, 255, 1);
		}
	}

	.nav-tool-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 9px;
	}

	::v-deep .nav-tool-bar .el-checkbox__label {
		color: var(--im-text-color-light);
		font-size: var(--im-font-size-small);
	}

	.link {
		text-decoration: none;
		color: rgba(135, 142, 153, 1);
		font-size: 16px;
		transition: color 0.2s ease;

		&:hover {
			color: rgba(31, 90, 255, 1);
		}
	}

	.submit-btn {
		width: 100%;
		height: 56px;
		margin-top: 24px;
		border-radius: 12px;
		border: none;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0;
		background: linear-gradient(180deg, rgba(31, 90, 255, 1) 0%, rgba(51, 133, 255, 1) 100%);
		transition: transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			transform: translateY(-1px);
		}
	}

	.demo-login-link {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-decoration: none;
		color: var(--im-color-primary);
		font-size: var(--im-font-size-small);

		&:hover {
			opacity: 0.85;
		}
	}
}
</style>